module.exports = __webpack_public_path__ + "static/img/icon0_active.3141d6c6.svg";